/**
 * Constant.ts
 * This component is used as a common file where we can declare some common constants.
 * These constants can be accessed and utilized throughout the entire project.
 */

import { TFilterModel } from "../types/config";
import { eOTHERREQUESTTYPE, ePERFORMANCE_RATING } from "./enum";

// Application Constants
export const APP_NAME = "IDEX FIA";
export const __prod__ = process.env.NODE_ENV === "production";
export const EMPTY_CHILDREN = "Please provide component to display";
export const LOGO_URL = "/assets/images/wnix-logo.png";
export const APP_ICON = "/assets/images/wnix-mnml-logo.png";
export const LOGO_URL_2x = "/assets/images/logo@2x.png";
export const HEADER_HEIGHT = 90;
export const DEFAULT_LANG = "en";

// Screen Breakpoints
export const SCREEN_BREAKPOINT = {
  mobile: 0,
  tablet: 768,
  computer: 1024,
};

export const ISUSERLOOGED_KEY = "iul";
export const SESSION_TIME_OUT = "sto";
export const SESSION_ISUSERLOOGED_KEY = "siul";
export const LOGGED_USER_ID = "lui";

// File Formats
export const FormatType = {
  JPEG: "image/jpeg",
  BMP: "image/bmp",
  PNG: "image/png",
  GIF: "image/gif",
  PDF: "application/pdf",
  JSON: "application/json",
  MSWORD: "application/msword",
  EXCEL: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
};

// Date Formats and Time
export const dateFormat = "dd-MMM-yyyy hh:mm:ss a";
export const dateOnlyFormat = "dd-MMM-yyyy";
export const monthOnlyFormat = "MMM-yyyy";

// Other Constants
export const debounceTime = 1000;
export const RESPONSE_STATUS = {
  SUCCESS: "R_SUCCESS",
  NO_DATA_FOUND: "R_NO_DATA_FOUND",
};

// Theme Variables and Class Names
export const DEFAULT_THEME_VARIABLES = [
  "primaryColor",
  "secondaryColor",
  "plateteFirstColor",
  "plateteSecondColor",
  "plateteThirdColor",
  "plateteFourthColor",
];
export const PLATETE_CLASS_NAMES = [
  "ax-bg-platete-first",
  "ax-bg-platete-second",
  "ax-bg-platete-third",
  "ax-bg-platete-fourth",
];

// Image Preloading
export const PreloadImagesPath = [];

// Confirmation Messages
export const REMOVE_MESSAGE = "Are you sure to remove?";

// Keys to Restrict in Numeric Input
export const NumberRestrictKeys = ["e", "E", "+", "-", "."];

// default filter params
export const defaultFilterParams: TFilterModel = {
  pageSize: 10,
  currentPage: 1,
  filterRowsCount: 0,
  totalRows: 0,
  searchText: "",
  orderType: "",
  orderBy: "",
};

export const CONFIG_GROUPS = {
  REGION: "REGION",
  LOCATIONTYPE: "LOCATIONTYPE",
  STAKEHOLDERS: "STAKEHOLDERS",
  TICKETSTATUS: "TICKETSTATUS",
  STATUSREASON: "STATU_80bad948-5814-4146-8c30-fe0909412b66",
  FREQUENCYOPT: "UPLOA_c09f979d-c8c2-4805-8b62-c8f6081b4ac4",
  TICKETTYPE: "TICKE_5ce98493-a4dc-4653-be76-b482502571f0",
  ISSUECATEGORY: "TICKE_f369b9c7-09a9-4a23-9201-6877849648a6",
  SUBISSUECATEGORY: "TICKE_af3d8253-8d44-4ea3-a64c-209c199cfc78",
  SUBISSUECATEGORY1:
    "TICKET SUB-ISSUE CATEGORY TWO_ebe93ea3-2c73-465d-a9d4-8817fb4340ed",
  ADLSTATUS: "ADL S_49ee3a71-3069-452e-a308-a1ea8e1efa4e",
  SLAOPTIONS: "SLA/T_6f1776c5-95c9-4717-8b1f-f83badb1dfce",
};

export const ISSUE_CATEGORY = {
  DISPENSER: "DISPE_f31558e7-36ea-42d9-bf94-8d5616b1025c",
  GYRO: "GYRO _901d0d5b-7d74-49e5-9e79-8c416056e41c",
  HARDWARED: "HARDW_b56b0118-35a7-4cd0-a4e8-c6e20067e7d6",
  SOFTWARED: "SOFTW_457b9451-bd4a-4835-b467-c5d83170a6d6",
  HARDWAREG: "HARDWARE - G_d00c158e-2856-460d-b428-f2389fd20aba",
  SOFTWAREG: "SOFTWARE - G_95ab19e1-b9da-44d1-abec-bae390a67fea",
};

export const STAKE_HOLDERS = {
  IDEX: "IDEX",
  CUSTOMER: "CUSTOMER",
  SERVICEPARTNER: "SERVICEPARTNER",
};

export const requestType = [
  { value: eOTHERREQUESTTYPE.PM, label: "PM" },
  { value: eOTHERREQUESTTYPE.GDATA, label: "G Data" },
  { value: eOTHERREQUESTTYPE.CHECKCALIBRATION, label: "Check Calibration" },
  { value: eOTHERREQUESTTYPE.GENERAL, label: "General" },
];
export const requestTypeFilters = [
  { value: 1, text: "PM" },
  { value: 2, text: "G Data" },
  { value: 3, text: "Check Calibration" },
  { value: 4, text: "General" },
];

export const ROLEUNIQUEID = {
  SUPERADMIN: "SUPERADMIN",
};

export const PageSize = -1;

export const PERFORMANCE_RATING_LABELS: Record<ePERFORMANCE_RATING, string> = {
  [ePERFORMANCE_RATING.POOR]: "Poor (frequent delays/absences)",
  [ePERFORMANCE_RATING.BELOW_AVERAGE]: "Below Avg",
  [ePERFORMANCE_RATING.MEETS_EXPECTATIONS]: "Meets Expectations",
  [ePERFORMANCE_RATING.ABOVE_AVERAGE]: "Above Avg",
  [ePERFORMANCE_RATING.EXCELLENT]: "Excellent (consistent & reliable)",
};
